// extracted by mini-css-extract-plugin
export default {"app":"Agreement_app__nHyTX"};